import axios from 'axios';

import Helpers from '../common/helpers';
import apiConstants from './constants/api-constants';

class ChangePasswordApi {
  static forgotPassword(email) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.change_password_routes.forgot_password, { email });

    return axios(request);
  }

  static resetPassword(email, verification_code, password) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.change_password_routes.reset_password, { email, verification_code, password });

    return axios(request);
  }

  static changePassword(user_name_OR_email, old_password, new_password) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.change_password_routes.change_password, { user_name_OR_email, old_password, new_password });

    return axios(request);
  }
}

export default ChangePasswordApi;



// WEBPACK FOOTER //
// ./src/api/change-password-api.js